module.exports = __webpack_public_path__ + "static/img/emptylist.28e2a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/emptylist.png
// module id = DpWm
// module chunks = 0